import React, { useState } from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath';
import { svgIcons } from '../../../../style/fonts/SvgIcons';
import Table from "../../../../core/common/dataTable/index";
import { MeetingsData } from './MeetingsData';
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Link } from 'react-router-dom';
import MeetingSidebar from './MeetingsSidebar/MeetingSidebar';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import CustomSelect from '../../../../core/common/selectPirority/SelectPirority';
import ModalComponent from '../../../../core/common/modal/ModalComponent';


const Meetings = () => {

  const [selectedRowId, setSelectedRowId] = useState<any[]>([]);
  const data = MeetingsData;
  const [activityTogglePopup, setActivityTogglePopup] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [showfilterModal, setShowfilterModal] = useState(false);

  const handleAddNotes = () => {
    setActivityTogglePopup(true);
    setIsEditing(false);
  };
  const handleEditNotes = () => {
    setActivityTogglePopup(true);
    setIsEditing(true)
  };
  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById('dropdownMenuClickableInsise');
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }
  const closeSidebar = () => {
    setActivityTogglePopup(false);
  };
  const handleClose = () => {
    setShowfilterModal(false)
  };
  const options1 = [
    { value: 'All Users', label: 'All Users' },
    { value: "Active Users", label: "Active Users" },
    { value: "Inactive Users", label: "Inactive Users" },
    { value: "Active Organization Admin", label: "Active Organization Admin" },
  ];

  const disable = selectedRowId.length > 1 || selectedRowId.length === 0;

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: true,
    },
    {
      title: "DATE",
      dataIndex: "created",
      key: "created",
      sorter: true,
    },
    {
      title: "HOST",
      render: (text: any, record: any) => (
        <div className="table-avatar d-flex align-items-center">
          <div className="company-img">
            <ImageWithBasePath src={record.image} alt="UserImage" />
          </div>
          <div
            className="profile-split d-flex flex-column"
          >
            {record.customer_name}
          </div>
        </div>
      ),
      sorter: true,
    },
    {
      title: "PRIORITY",
      dataIndex: "priority",
      render: (text: string) => (
        <div>
          {text === "Low" && (
            <span className="badge badge-pill badge-status bg-soft-success text-success">
              <i className="fa fs-10 fa-circle" />  {text}
            </span>
          )}

          {text === "High" && (
            <span className="badge badge-pill badge-status bg-soft-danger text-danger">
              <i className="fa fs-10 fa-circle" />  {text}
            </span>
          )}
          {text === "Medium" && (
            <span className="badge badge-pill badge-status bg-soft-warning text-warning">
              <i className="fa fs-10 fa-circle" />  {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      render: (text: string) => (
        <div>
          {text === "Completed" && (
            <span className="badge badge-pill badge-status bg-soft-success text-success">
              {text}
            </span>
          )}

          {text === "Canceled" && (
            <span className="badge badge-pill badge-status bg-soft-danger text-danger">
              {text}
            </span>
          )}
          {text === "Upcoming" && (
            <span className="badge badge-pill badge-status bg-soft-warning text-warning">
              {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
  ];


  return (
    <>
     <ModalComponent
        modalTitle='Saving Current Filters'
        isVisible={showfilterModal}
        cancelButton="Cancel"
        onClose={handleClose}
        saveButton='Save'
        className="p-2"

      >
        <>
          <div className="col-md-12">
            <label className="col-form-label">
              Filter Name<span className="text-danger"> *</span>
            </label>
            <input type="text" className="form-control" />
          </div>
        </>

      </ModalComponent>
      <MeetingSidebar activityTogglePopup={activityTogglePopup} closeSidebar={closeSidebar} isEditing={isEditing} />
      <div className='row'>
        <div className='col-md-12'>
          <div className="card main-card">
            <div className="card-body">
              {/* Search */}
              <div className="search-section">
                <div className="row">
                  <div className='d-flex justify-content-between'>
                    <div className="col-md-8 col-sm-12 d-flex gap-3  align-items-center">
                      <div className="filter-section filter-flex w-100 ">
                        <div className="filter-list">
                          <ul>
                          <li>
                              <div className=" icon-form">
                                <span className="form-icon">
                                  <i className="ti ti-search" />
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search"
                                />
                              </div>
                            </li>
                            <li>
                              <div className="form-sorts dropdown">
                              <button
                                    className="btn border-gray dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuClickableInsise"
                                    data-bs-toggle="dropdown"
                                    data-bs-auto-close='false'
                                    aria-expanded="false"
                                  >
                                    <i className="ti ti-filter-share" />
                                    Filter
                                  </button>
                                <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end">
                                  <div className="filter-set-view">
                                    <div className="filter-set-head">
                                    <div className="d-flex gap-2">
                                          <h4>Filter</h4>(<CustomSelect options={options1} >
                                            <div className="d-flex gap-2" style={{ cursor: 'pointer' }}>
                                              {svgIcons.ManageIcon}
                                              <p>Manage</p>
                                            </div>
                                          </CustomSelect>
                                          )
                                        </div>
                                    </div>
                                    <hr />
                                    <div>
                                      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                        <Row>
                                          <Col sm={12}>
                                            <Nav variant="pills" className="flex">
                                              <Nav.Item>
                                                <Nav.Link eventKey="first">All Filters</Nav.Link>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <Nav.Link eventKey="second">My Filters</Nav.Link>
                                              </Nav.Item>
                                            </Nav>
                                          </Col>
                                          <Col sm={12} className="mt-3">
                                            <Tab.Content>
                                              <Tab.Pane eventKey="first">
                                                <div
                                                  className="accordion"
                                                  id="accordionExample"
                                                >
                                                  <div className="filter-set-content">
                                                    <div className="filter-set-content-head">
                                                      <Link
                                                        to="#"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#ID"
                                                        aria-expanded="true"
                                                        aria-controls="ID"
                                                      >
                                                        ID
                                                      </Link>
                                                    </div>
                                                    <div
                                                      className="filter-set-contents accordion-collapse collapse show"
                                                      id="ID"
                                                      data-bs-parent="#accordionExample"
                                                    >
                                                      <div className="filter-content-list">
                                                        <div className="form-wrap icon-form">
                                                          <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                          </span>
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search "
                                                          />
                                                        </div>
                                                        <ul>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input
                                                                  type="checkbox"
                                                                  defaultChecked
                                                                />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Darlee Robertson</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5> Sharon Roy</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Robertson</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Sharon</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Jessica</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Carol Thomas</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Thomas</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Jessica</h5>
                                                            </div>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="filter-set-content">
                                                    <div className="filter-set-content-head">
                                                      <Link
                                                        to="#"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#collapseTwo"
                                                        aria-expanded="true"
                                                        aria-controls="collapseTwo"
                                                      >
                                                        Date
                                                      </Link>
                                                    </div>
                                                    <div
                                                      className="filter-set-contents accordion-collapse collapse "
                                                      id="collapseTwo"
                                                      data-bs-parent="#accordionExample"
                                                    >
                                                      <div className="filter-content-list">
                                                        <div className="form-wrap icon-form">
                                                          <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                          </span>
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search "
                                                          />
                                                        </div>
                                                        <ul>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input
                                                                  type="checkbox"
                                                                  defaultChecked
                                                                />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Darlee Robertson</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5> Sharon Roy</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Robertson</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Sharon</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Jessica</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Carol Thomas</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Thomas</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Jessica</h5>
                                                            </div>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="filter-set-content">
                                                    <div className="filter-set-content-head">
                                                      <Link
                                                        to="#"
                                                        className="collapsed"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#email"
                                                        aria-expanded="false"
                                                        aria-controls="email"
                                                      >
                                                        Host
                                                      </Link>
                                                    </div>
                                                    <div
                                                      className="filter-set-contents accordion-collapse collapse"
                                                      id="email"
                                                      data-bs-parent="#accordionExample"
                                                    >
                                                      <div className="filter-content-list">
                                                        <div className="form-wrap icon-form">
                                                          <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                          </span>
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search Owner"
                                                          />
                                                        </div>
                                                        <ul>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input
                                                                  type="checkbox"
                                                                  defaultChecked
                                                                />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Hendry</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Guillory</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Jami</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Theresa</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Espinosa</h5>
                                                            </div>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="filter-set-content">
                                                    <div className="filter-set-content-head">
                                                      <Link
                                                        to="#"
                                                        className="collapsed"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#role"
                                                        aria-expanded="false"
                                                        aria-controls="role"
                                                      >
                                                        Priority
                                                      </Link>
                                                    </div>
                                                    <div
                                                      className="filter-set-contents accordion-collapse collapse"
                                                      id="role"
                                                      data-bs-parent="#accordionExample"
                                                    >
                                                      <div className="filter-content-list">
                                                        <div className="form-wrap icon-form">
                                                          <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                          </span>
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search Owner"
                                                          />
                                                        </div>
                                                        <ul>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input
                                                                  type="checkbox"
                                                                  defaultChecked
                                                                />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Hendry</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Guillory</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Jami</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Theresa</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Espinosa</h5>
                                                            </div>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="filter-set-content">
                                                    <div className="filter-set-content-head">
                                                      <Link
                                                        to="#"
                                                        className="collapsed"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Status"
                                                        aria-expanded="false"
                                                        aria-controls="Status"
                                                      >
                                                        Status
                                                      </Link>
                                                    </div>
                                                    <div
                                                      className="filter-set-contents accordion-collapse collapse"
                                                      id="Status"
                                                      data-bs-parent="#accordionExample"
                                                    >
                                                      <div className="filter-content-list">
                                                        <ul>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input
                                                                  type="checkbox"
                                                                  defaultChecked
                                                                />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Active</h5>
                                                            </div>
                                                          </li>
                                                          <li>
                                                            <div className="filter-checks">
                                                              <label className="checkboxs">
                                                                <input type="checkbox" />
                                                                <span className="checkmarks" />
                                                              </label>
                                                            </div>
                                                            <div className="collapse-inside-text">
                                                              <h5>Inactive</h5>
                                                            </div>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="filter-reset-btns">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                          <Link
                                                            to="#"
                                                            className="color-red"
                                                            onClick={()=>handlefiltermodel()}
                                                          >
                                                            Save Current Filter
                                                          </Link>
                                                        </div>
                                                        <div className="d-flex gap-2 ">
                                                          <div >
                                                            <Link
                                                              to="#"
                                                              className="btn btn-light-red"
                                                            >
                                                              Reset
                                                            </Link>
                                                          </div>
                                                          <div>
                                                            <Link
                                                              to='#'
                                                              className="btn btn-primary"
                                                            >
                                                              Apply
                                                            </Link>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </Tab.Pane>
                                              <Tab.Pane eventKey="second">Second tab content</Tab.Pane>
                                            </Tab.Content>
                                          </Col>
                                        </Row>
                                      </Tab.Container>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>                         
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-8">
                      <div className='d-flex justify-content-end gap-3'>
                        <button className="btn btn-transparent border-0" disabled={disable} onClick={handleEditNotes}><span className='me-2'>{svgIcons.updateIcon}</span>Edit</button>
                        <button className="btn btn-primary" onClick={handleAddNotes}>+ New Meeting</button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              {/* Projects List */}
              <div className="table-responsive overflow-md-auto custom-table">
                <Table dataSource={data} columns={columns} onRowSelect={(keys: any[]) => setSelectedRowId(keys)} />
              </div>
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="TableData-length" />
                </div>
                <div className="col-md-6">
                  <div className="TableData-paginate" />
                </div>
              </div>
              {/* /Projects List */}
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default Meetings
